import { render, staticRenderFns } from "./FastTemplate.vue?vue&type=template&id=bde48e02&scoped=true&"
import script from "./FastTemplate.vue?vue&type=script&lang=js&"
export * from "./FastTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FastTemplate.vue?vue&type=style&index=0&id=bde48e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde48e02",
  null
  
)

export default component.exports